import HistorialInventarioService from 'src/modules/historialInventario/historialInventarioService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import {getHistory} from 'src/modules/history';
import {i18n} from 'src/i18n';
import moment from 'moment-timezone';
import layoutActions from 'src/modules/layout/layoutActions';

const prefix = 'HISTORIALINVENTARIO_FORM';

const historialInventarioFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: id => async dispatch => {
    try {
      dispatch({
        type: historialInventarioFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await HistorialInventarioService.find(id);
      }

      dispatch({
        type: historialInventarioFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: historialInventarioFormActions.INIT_ERROR,
      });

      getHistory().push('/historial-inventario');
    }
  },

  doCreate: values => async dispatch => {
    try {
      dispatch({
        type: historialInventarioFormActions.CREATE_STARTED,
      });

      await HistorialInventarioService.create(values);

      dispatch({
        type: historialInventarioFormActions.CREATE_SUCCESS,
      });

      Message.success(i18n('entities.historialInventario.create.success'));

      // getHistory().push('/historial-inventario');

      dispatch(
        layoutActions.doVisibleDrawer({
          drawerId: 'DrawerHistorialInventarioFormPage',
          drawerVisible: false,
          drawerChanged: moment().unix(),
          drawerUpdateComponent: 'HistorialInventarioListFilter',
        }),
      );
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: historialInventarioFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: historialInventarioFormActions.UPDATE_STARTED,
      });

      await HistorialInventarioService.update(id, values);

      dispatch({
        type: historialInventarioFormActions.UPDATE_SUCCESS,
      });

      Message.success(i18n('entities.historialInventario.update.success'));

      getHistory().push('/historial-inventario');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: historialInventarioFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default historialInventarioFormActions;
